import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import Snack from "@mui/material/SnackbarContent";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
// @mui/icons-material
import Close from "@mui/icons-material/Close";
// core components

import classNames from "classnames";
import styles from "./SnackbarContent.module.scss";

export default function SnackbarContent(props) {
  const { message, color, close, icon } = props;
  var action = [];
  const closeAlert = () => {
    setAlert(null);
  };
  if (close !== undefined) {
    action = [
      <IconButton
        className={styles.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
        onClick={closeAlert}
        size="large"
      >
        <Close className={styles.close} />
      </IconButton>,
    ];
  }
  let snackIcon = null;
  switch (typeof icon) {
    case "object":
      snackIcon = <props.icon className={styles.icon} />;
      break;
    case "string":
      snackIcon = <Icon className={styles.icon}>{props.icon}</Icon>;
      break;
    default:
      snackIcon = null;
      break;
  }
  const [alert, setAlert] = React.useState(
    <Snack
      message={
        <div>
          {snackIcon}
          {message}
          {close !== undefined ? action : null}
        </div>
      }
      classes={{
        root: classNames(styles.root, styles[color], styles.noMargin),
        message: classNames(styles.message, styles.container),
      }}
    />
  );
  return alert;
}

SnackbarContent.propTypes = {
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
